import { render, staticRenderFns } from "./BuildingList.vue?vue&type=template&id=41798c30"
import script from "./BuildingList.vue?vue&type=script&lang=js"
export * from "./BuildingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports